import React from "react";
import { ContactCard } from "./ContactCard/ContactCard";
import ContactData from "./Contacts.json";
import OfficeImg from "../../assets/office.jpg";
import "./Contacts.scss";

interface IContactData {
  type: string;
  name: string;
  title: string;
  phone: string;
  email: string;
  fax?: string;
}

export const Contacts: React.FC = () => {
  let contactData: IContactData[] = ContactData.contacts;
  const executives = contactData.filter(
    (contact) => contact.type === "executive"
  );
  const corporate = contactData.filter(
    (contact) => contact.type === "corporate"
  );
  const hr = contactData.filter((contact) => contact.type === "hr");
  return (
    <div className="Contacts">
      <div className="Contacts_header page-header">
        <h1>Contact Us</h1>
        <div>
          <p>
            Though communication is key, it begins by reaching out. Contact
            PROSOFT for business or employment opportunities.
          </p>
        </div>
      </div>
      <div className="Contacts__content">
        <div className="Contacts_Locations Contacts__section">
          <h2 className="section-header">Office Locations</h2>
          <div className="Contacts_Locations-content Contacts__section__content">
            <div className="Locations__header">
              <img
                className="Locations__header__img"
                src={OfficeImg}
                alt="Corporate Office Building"
              />
              <p className="Locations__header__text">
                We are headquartered in Virginia Beach, VA, with technical
                engineering and administrative staff serving in various
                locations.
              </p>
            </div>
            <div className="headquarters">
              <div className="headquarters__va headquarters__card">
                <span className="headquarters-title">Virginia Beach, VA</span>
                <div className="headquarters__card__body">
                  <span>500 Viking Dr. - Suite 301</span>
                  <span>Virginia Beach, VA 23452</span>
                  <span>Phone: (757) 431-2400</span>
                  <span>Fax: (757) 463-1071</span>
                </div>
              </div>
              <div className="headquarters__sc headquarters__card">
                <span className="headquarters-title">Hanahan, SC</span>
                <div className="headquarters__card__body">
                  <span>1002 Trident Street - Suite 200</span>
                  <span>Hanahan, SC 29410</span>
                  <span>Phone: (843) 225-2142</span>
                </div>
              </div>
            </div>
            <div className="service-areas">
              <h3>Serving the following areas:</h3>
              <ul className="service-areas__locations">
                <li>Virigina Beach, VA</li>
                <li>Norfolk, VA</li>
                <li>Suffolk, VA</li>
                <li>Chesapeake, VA</li>
                <li>Charleston, SC</li>
              </ul>
            </div>
          </div>
          <div className="Contacts_Contacts Contacts__section">
            <h2 className="section-header">Contacts</h2>
            <div className="Contacts_Contacts-list Contacts__section__content">
              <div className="Contacts__section__content__inner">
                <div className="Contacts__section__content__inner__header">
                  <h3>Executive</h3>
                </div>
                <div className="Contacts__section__content__inner__body">
                  {executives.map((exec) => {
                    return (
                      <ContactCard
                        name={exec.name}
                        email={exec.email}
                        title={exec.title}
                        phone={exec.phone}
                        fax={exec.fax ?? ""}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="Contacts__section__content__inner">
                <div className="Contacts__section__content__inner__header">
                  <h3>Corporate</h3>
                </div>
                <div className="Contacts__section__content__inner__body">
                  {corporate.map((corp) => {
                    return (
                      <ContactCard
                        name={corp.name}
                        email={corp.email}
                        title={corp.title}
                        phone={corp.phone}
                        fax={corp.fax ?? ""}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="Contacts__section__content__inner">
                <div className="Contacts__section__content__inner__header">
                  <h3>Human Resources</h3>
                </div>
                <div className="Contacts__section__content__inner__body">
                  {hr.map((rep) => {
                    return (
                      <ContactCard
                        name={rep.name}
                        email={rep.email}
                        title={rep.title}
                        phone={rep.phone}
                        fax={rep.fax ?? ""}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
